import { Component, OnInit } from '@angular/core';
import { Subscription, tap } from 'rxjs';
import { ModalMessageComponent, ModalMessageType } from 'src/app/component/controls/modal-message/modal-message.component';
import { ModalConfig } from 'src/app/component/controls/modal/modal-config';
import { ModalRef } from 'src/app/component/controls/modal/modal-ref';
import { Modal } from 'src/app/component/controls/modal/modal.service';
import { ActivityService } from 'src/app/service/activity.service';

@Component({
  selector: 'app-sclogs',
  templateUrl: './sclogs.component.html',
  styleUrl: './sclogs.component.css',
  standalone: false
})
export class SclogsComponent implements OnInit {
  width:string;
  text:string;
  activityId:number;
  intervalId: number | undefined;
  count: number = 0;
  progressCounter: number = 0;
  isCompleted: boolean = false;

  constructor(private modalRef: ModalRef, public modalConfig: ModalConfig,
    private activityService: ActivityService, protected modal: Modal) {
    this.activityId = this.modalConfig.data.activityId;
   }

  ngOnInit(): void {
    this.text = $localize`Generating Log Packages.`;
    setTimeout(() => {
      this.startGetActivityInfoInterval();
    }, 1000);
  }

  startGetActivityInfoInterval(): void {
    this.isCompleted = false;
    this.intervalId = window.setInterval(() => {
      this.activityService.getActivityById(this.activityId).pipe(
        tap(resp => {
          if(resp.body.status === "COMPLETED"){
            this.isCompleted = true;
            this.stopGetActivityInfoInterval();
            this.text = $localize`Log collection complete! Please wait while we redirect you to the next step...`;
            setTimeout(() => {
              var args = JSON.parse(resp.body.args);
              this.modalRef.close({isSuccess: true, taskId: args.body});
            }, 3000);
          }else if(resp.body.status === "ERROR"){
            this.stopGetActivityInfoInterval();
            this.modalRef.close({isSuccess: false});
          }else{
            if(this.count % 10 == 0 && this.progressCounter < 10) {
              this.text += '.';
              this.progressCounter++;
            }
            this.count++;
          }
        })).subscribe();
      }, 1000);
  }

  stopGetActivityInfoInterval(): void {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  exit(): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Exit`,
          message:  $localize`Are you sure you want to exit? The log packages will continue to be collected in the background.`,
          type: ModalMessageType.Question,
          primaryBtn: $localize`Yes`,
          secondaryBtn: $localize`No`,
          width: '475px'
        },
        id: 'otsc-log-package-exit-confirm-dlg'
      }
      ).afterClosed.subscribe((result: boolean) => {
        if (result) {
          this.stopGetActivityInfoInterval();
          this.modalRef.close({isSuccess: true, taskId: ""});
        }
        sub.unsubscribe();
      });
  }
}
